const style = theme => ({
  contentWrapper: {
    padding: theme.spacing(2),
  },
})

export default style
